(function () {
  'use strict';

  // The travel curves come in pairs that only compose correctly when the browser
  // can accumulate two animations on the same `translate` property.
  var SUPPORTED =
    typeof window.CSS === 'object' &&
    typeof window.CSS.supports === 'function' &&
    window.CSS.supports('animation-composition', 'accumulate');

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Card and gallery images sit side by side in a scrolling track, so the first
  // one in the DOM is usually not the one the shopper is looking at.
  function visibleImage(container) {
    if (!container) return null;
    var images = container.querySelectorAll('img');
    if (!images.length) return null;
    if (images.length === 1) return images[0];

    var bounds = container.getBoundingClientRect();
    var middle = bounds.left + bounds.width / 2;
    var best = null;
    var bestDistance = Infinity;

    Array.prototype.forEach.call(images, function (image) {
      var rect = image.getBoundingClientRect();
      if (!rect.width) return;
      var distance = Math.abs(rect.left + rect.width / 2 - middle);
      if (distance < bestDistance) {
        bestDistance = distance;
        best = image;
      }
    });

    return best || images[0];
  }

  function imageFor(button) {
    var sheet = button.closest('[data-card-sizes]');
    var scope = button.closest('[data-product-card]') ||
      button.closest('[data-size-host]') ||
      (sheet && sheet._host) ||
      button.closest('[data-sticky-atc]');
    var image = visibleImage(scope);
    if (!image) image = visibleImage(document.querySelector('[data-product-gallery]'));
    if (!image) return null;

    var src = image.currentSrc || image.src || '';
    // Only our own CDN-rendered sources, and nothing that could break out of url().
    if (!/^(https?:)?\/\/|^\//.test(src)) return null;
    if (/["')\\]/.test(src)) return null;
    return src;
  }

  function fly(button) {
    if (!SUPPORTED || reduced.matches) return;
    if (!button || typeof button.getBoundingClientRect !== 'function') return;

    var cartIcon = document.querySelector('[data-cart-drawer-open]');
    if (!cartIcon) return;

    var sheet = button.closest('[data-card-sizes]');
    var host = button.closest('[data-size-host]') || (sheet && sheet._host);
    var photo = host && visibleImage(host);
    var fromPhoto = !!(button.closest('.product-card__size') && photo && photo.getBoundingClientRect().width);
    var source = fromPhoto ? photo.getBoundingClientRect() : button.getBoundingClientRect();
    var target = cartIcon.getBoundingClientRect();
    if (!source.width || !target.width) return;

    var image = imageFor(button);
    if (!image) return;

    var start = { x: source.left + source.width / 2, y: source.top + source.height / 2 };
    var end = { x: target.left + target.width / 2, y: target.top + target.height / 2 };

    var el = document.createElement('div');
    el.className = 'fly-to-cart';
    // The product-page curve overshoots off screen when the photo is not
    // already beside the cart. Card size clicks use the arc that stays in view.
    if (fromPhoto || (button.closest('[data-product-card]') && !button.closest('.product-card__size'))) {
      el.classList.add('fly-to-cart--quick');
    }
    el.setAttribute('aria-hidden', 'true');
    el.style.backgroundImage = 'url("' + image + '")';
    el.style.setProperty('--fly-start-x', start.x + 'px');
    el.style.setProperty('--fly-start-y', start.y + 'px');
    el.style.setProperty('--fly-travel-x', end.x - start.x + 'px');
    el.style.setProperty('--fly-travel-y', end.y - start.y + 'px');

    document.body.appendChild(el);

    var animations = el.getAnimations();
    if (!animations.length) {
      el.remove();
      return;
    }
    Promise.allSettled(
      animations.map(function (animation) {
        return animation.finished;
      })
    ).then(function () {
      el.remove();
    });
  }

  window.BelnayFlyToCart = fly;
})();
